module.exports = __webpack_public_path__ + "img/vertical_7_1_6005.4b5498bd.png";